<div class="change-history">
    <ng-container *ngIf="historyDetails?.length; else noHistory">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">User</th>
            <th scope="col">Status</th>
            <th scope="col">Comments</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of historyDetails">
            <td>{{ item.actionDate | date: 'medium' }}</td>
            <td>
              {{
                item.userInfo.displayName
                  || item.userInfo.name
                  || item.userInfo.email
                  || 'Unknown'
              }}
            </td>
            <td>{{ item.status }}</td>
            <td>{{ item.comments || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
    <ng-template #noHistory>
      <p>No change history available.</p>
    </ng-template>
  </div>
  